// Partner-navbar configuration of the shared command palette (command_palette.mjs). The
// generic ranking, cache, and row markup live there; this module only pins the partner
// palette's own types and its one extra view (the partner switcher).
import {
  MAX_RESULTS,
  rankCommandResults,
} from "./command_palette.mjs";

export {
  EMPTY_PREFIX_MIN_LENGTH,
  MAX_RESULTS,
  MIN_REMOTE_QUERY_LENGTH,
  NavigationRecordCache,
  RECORD_CACHE_LIMIT,
  REMOTE_SEARCH_DEBOUNCE_MS,
  commandGroupHeader,
  commandResultRow,
  escapeHtml,
  highlightMatch,
  isCommandSearchShortcut,
  normalizeTransientNavigationState,
  platformModifierLabel,
} from "./command_palette.mjs";

// The partner list ships with the bar and matches locally, so its cap is about how much
// of it is worth scrolling rather than about request cost.
export const MAX_PARTNER_RESULTS = 50;
// Pages, saved views, actions, and configuration tabs ship with the navbar and have no
// server pass, so they must match locally.
const LOCAL_TYPES = ["page", "view", "action", "setting"];
// Configuration tabs are one level below the Configuration page, so they are listed only
// once something is typed rather than crowding the blank-query list.
const BLANK_QUERY_TYPES = ["page", "view", "action"];
const TYPE_ORDER = ["page", "view", "setting", "action", "claim", "member"];
// An action is the only way into the view it opens, so the cap must not be able to drop
// one: actions sort after pages and saved views, and a partner with enough saved views
// would otherwise hide Switch Partners behind a query the user has to already know.
const UNCAPPED_TYPES = ["action"];

export function rankNavigationResults(shortcuts, records, query, { recordsAreCurrent = true } = {}) {
  return rankCommandResults(shortcuts, records, query, {
    recordsAreCurrent,
    localTypes: LOCAL_TYPES,
    blankQueryTypes: BLANK_QUERY_TYPES,
    typeOrder: TYPE_ORDER,
    uncappedTypes: UNCAPPED_TYPES,
    maxResults: MAX_RESULTS,
  });
}

// The partner list is a secondary search view: one flat, already alphabetical group that
// the query only filters. Ranking it would reorder it, and an admin looking for a partner
// by name is served better by the alphabetical position they expect. The query matches the
// slug (the row's meta) as well as the name, since the slug is what an admin sees in URLs
// and logs, and it is the only thing separating two partners with similar names.
export function rankPartnerResults(partners, query) {
  const normalizedQuery = String(query || "").trim().toLowerCase();
  const matches = normalizedQuery
    ? partners.filter((partner) => [partner.title, partner.meta].some((field) => String(field || "").toLowerCase().includes(normalizedQuery)))
    : partners;

  return matches.slice(0, MAX_PARTNER_RESULTS);
}
